import React, { Component } from 'react';
import { Container, Row, Col, Input, Table, Button } from 'reactstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import Session from '../auth/Session';
import AdminFunctions from './AdminFunctions';
import utilities from '../util/utilities';
import { FaSort } from 'react-icons/fa'
import '../layout/site.css';

export class Users extends Component {
    static displayName = Users.name;

    constructor(props) {
        super(props);

        this.state = {
            users: [],
            search: null,
            clientOptions: [],
            client: null,
            height: 0,
            width: 0,
            sort: {
                column: null,
                direction: 'desc'
            },
        };

        window.addEventListener('resize', this.setWindowDimensions);        

    }

    async componentDidMount() {
        const isAdmin = await AdminFunctions.isAdminAsync();
        if (!isAdmin) {
            this.props.history.push('/accessdenied');
            return;
        }
        this.setWindowDimensions();
        this.getUsers();
    }

    render() {
        return (
            <div>
                <Container className='container-main'>
                    <Row style={{display: 'flex', justifyContent: 'flex-end'}}>
                        <div>
                            <Button
                                color='primary'
                                onClick={() => this.props.history.push({ pathname: '/admin/users/details', state: { existingUser: false }})}
                                style={{ whiteSpace: 'nowrap', alignSelf: 'flex-end' }}
                            >
                                + Add
                            </Button>
                        </div>                      
                    </Row>
                    <Row className='row-20'>
                        <Col>
                            <Table bordered hover>
                                <thead>
                                    <tr>
                                        <th>
                                            Last Name
                                        </th>
                                        <th>
                                            First Name
                                        </th>
                                        <th>
                                            Role
                                        </th>
                                        <th>
                                            Email
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.users.map((user, i) => {
                                        return (
                                            <tr
                                                key={user.id}
                                                onClick={() => this.handleRowClick(user.id)}
                                            >
                                                <td>{user.lastName}</td>
                                                <td>{user.firstName}</td>
                                                <td>{user.role}</td>
                                                <td>{user.email}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>                    
                </Container>
            </div>
        )
    }

    async getClientDropdown() {
        const token = Session.getToken();

        const response = await fetch(`api/Clients/GetDropdown`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        this.setState({ clientOptions: data });
    }

    async getUsers() {
        const token = Session.getToken();

        const response = await fetch(`api/Admin/GetUsersAsync`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        this.setState({ users: data });
    }

    async searchUsers() {
        const token = Session.getToken();

        const response = await fetch(`api/Admin/SearchUsersAsync?query=${this.state.search}`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`}
        });
        const data = await response.json();
        this.setState({ users: data });
    }

    handleRowClick(userId) {
        this.props.history.push({
            pathname: '/admin/users/details',
            state: { userId: userId, existingUser: true }
        })
    }

    setWindowDimensions = () => {
        this.setState({
            height: window.innerHeight,
            width: window.innerWidth
        });
    };

    // table sort

    handleSort(column) {
        const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
        const data = this.state.users;
        data.sort((a, b) => a[column].localeCompare(b[column]))
        if(direction === 'desc') {
            data.reverse();
        }
        this.setState({
            users : data,
            sort: {
                column,
                direction
            }
        })
    };

}